import { Auth } from 'aws-amplify'

export default function useSignOut() {
  const signOut = () => {
    Auth.signOut().catch(console.error)
  }

  return signOut
}
